module.exports = "/_next/static/images/payments-d7db71316b0010423bf71a57899e3858.png";